import React, { useState } from 'react';
import { Card } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FaPlus } from 'react-icons/fa';

function EducationEmploymentAddForm({ name, nextlink }) {
  const navigate = useNavigate();
  const [hover, setHover] = useState(false);

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3 }}
      className="mt-3"
    >
      <Card
        className="shadow border-0"
        style={{
          borderRadius: '20px',
          overflow: 'hidden',
          cursor: 'pointer',
          transition: 'all 0.3s ease',
          border: hover 
            ? '2px solid var(--bs-primary)'
            : '2px dashed var(--bs-border-color, #dee2e6)',
          minHeight: '75px',
          boxShadow: hover 
            ? '0 .5rem 1rem rgba(102, 126, 234, 0.2)' 
            : '0 .125rem .25rem rgba(0,0,0,.075)'
        }}
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
        onClick={() => navigate(nextlink)}
        role="button"
      >
        <Card.Body className="p-3 d-flex align-items-center justify-content-center">
          <motion.div
            className="d-flex align-items-center"
          >
            <div
              className="d-flex align-items-center justify-content-center rounded-circle me-2"
              style={{
                width: '35px',
                height: '35px',
                background: hover ? 'linear-gradient(135deg, var(--bs-primary) 0%, #0056b3 100%)' : 'linear-gradient(135deg, #0056b3 0%, var(--bs-primary) 100%)',
                transition: 'all 0.3s ease'
              }}
            >
              <FaPlus 
                size={16} 
                style={{ 
                  color: 'white',
                  transition: 'all 0.3s ease'
                }} 
              />
            </div>
            <span
              className="fw-semibold"
              style={{
                fontSize: '0.95rem',
                color: hover ? 'var(--bs-primary)' : 'var(--bs-body-color)',
                textDecoration: hover ? 'underline' : 'none',
                transition: 'all 0.3s ease'
              }}
            >
              {name}
            </span>
          </motion.div>
        </Card.Body>
      </Card>
    </motion.div>
  );
}

export default EducationEmploymentAddForm;